<template>
    <div>
        <!-- 搜索区：审核状态筛选 -->
        <div class="page-filter-box">
            <el-row :gutter="20">
                <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4">
                    <el-select v-model="params.auditStatus" placeholder="请选择" size="small">
                        <el-option label="不限制审核状态" :value="-1"></el-option>
                        <el-option label="仅看待审核" :value="0"></el-option>
                        <el-option label="仅看已通过" :value="1"></el-option>
                        <el-option label="仅看已拒绝" :value="2"></el-option>
                    </el-select>
                </el-col>
                <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4" class="page-filter-btns">
                    <el-button type="primary" icon="el-icon-search" @click="search" size="small">查询</el-button>
                    <el-button type="default" icon="el-icon-refresh" @click="reset" size="small">重置</el-button>
                </el-col>
            </el-row>
        </div>
        <!-- 表格区 -->
        <div class="page-list-box">
            <el-table :data="dataList" border style="width: 100%" v-loading="listLoading" size="small" stripe>
                <el-table-column label="审核状态">
                    <template slot-scope="{row}">
                        <el-tag :type="auditStatusMap[row.auditStatus] || 'info'" size="mini">{{ row.auditStatusView }}</el-tag>
                    </template>
                </el-table-column>
                
                <!-- 列字段按需求文档：审核状态/活动id/活动名称/活动有效时间/活动展示时间/创建 -->
                <el-table-column prop="activityId" label="活动id"></el-table-column>
                <el-table-column prop="activityTitle" label="活动名称" min-width="150" show-overflow-tooltip></el-table-column>
                <el-table-column label="活动有效时间" min-width="170">
                    <template slot-scope="{row}">
                        <p>起：{{ row.startTimeStr || '-' }}</p>
                        <p>止：{{ row.endTimeStr || '-' }}</p>
                    </template>
                </el-table-column>
                <el-table-column label="活动展示时间" min-width="170">
                    <template slot-scope="{row}">
                        <p>起：{{ row.onTimeStr || '-' }}</p>
                        <p>止：{{ row.offTimeStr || '-' }}</p>
                    </template>
                </el-table-column>
                <el-table-column label="创建" min-width="200">
                    <template slot-scope="{row}">
                        <p>创建时间：{{ row.submitTime || row.createTime || '-' }}</p>
                        <p>创建人：{{ row.creatorName || '-' }}</p>
                    </template>
                </el-table-column>
                <el-table-column fixed="right" label="操作" width="160">
                    <template slot-scope="{row}">
                        <el-button v-if="$utils.have('/share/activity/audit/detail')" type="text" size="small"
                            @click="toDetail(row)">查看</el-button>
                        <el-button v-if="$utils.have('/share/activity/audit/approve') && row.auditStatus == 0"
                            type="text" size="small" @click="approve(row)">通过</el-button>
                        <el-button v-if="$utils.have('/share/activity/audit/reject') && row.auditStatus == 0"
                            type="text" size="small" class="color-danger" @click="openReject(row)">拒绝</el-button>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <!-- 分页区 -->
        <div v-if="data" class="page-pagination-box">
            <el-pagination background @size-change="handleSizeChange" @current-change="getDataList"
                :current-page.sync="params.pageNo" :page-sizes="$pageSizes" :page-size.sync="params.pageSize"
                layout="total, sizes, prev, pager, next" :total="data.totalCount || 0">
            </el-pagination>
        </div>
        <!-- 拒绝审核弹窗：填写拒绝原因 -->
        <el-dialog title="拒绝审核" :visible.sync="rejectDialogShow" width="520px" :close-on-click-modal="false">
            <el-form :model="rejectForm" :rules="rejectRules" ref="rejectForm" label-position="top">
                <el-form-item label="拒绝原因:" prop="rejectReason">
                    <el-input type="textarea" v-model="rejectForm.rejectReason" placeholder="请输入拒绝原因"
                        maxlength="100" show-word-limit :rows="4"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer">
                <el-button size="medium" @click="rejectDialogShow = false">取 消</el-button>
                <el-button type="danger" size="medium" :loading="btnLoading" @click="submitReject">确 认 拒 绝</el-button>
            </div>
        </el-dialog>
    </div>
</template>
<script>
// 默认搜索参数（模块级常量，reset 时整体替换）
const defaultParams = {
    pageNo: 1,
    auditStatus: -1
};
export default {
    name: 'ShareActivityAuditList',
    props: {
        // 审核类型：1 创建审核 2 编辑审核
        auditType: {
            type: [Number, String],
            required: true
        },
        // 当前 tab 标识（由父组件传入，用于跳详情时还原 tab；不用 $route.query.tab，因其可能滞后于内存切换）
        tabName: {
            type: String,
            default: ''
        }
    },
    data() {
        return {
            data: null,
            dataList: null,
            // 仅当 URL query 的 tab 与当前审核 tab 匹配时（redirect 返回/刷新场景），才从 query 恢复筛选与分页；纯内存切换时用默认参数
            params: {
                ...defaultParams,
                pageNo: this.isQueryTabMatched() ? parseInt(this.$route.query.pageNo || 1) : 1,
                
                // pageSize 同样需守卫：避免纯内存切 tab 时残留其他 tab 的每页条数
                pageSize: this.isQueryTabMatched() ? parseInt(this.$route.query.pageSize || this.$pageSizes[0]) : this.$pageSizes[0],
                auditStatus: this.isQueryTabMatched() ? parseInt(this.$route.query.auditStatus != undefined ? this.$route.query.auditStatus : -1) : -1
            },
            listLoading: true,
            btnLoading: false,
            // 拒绝弹窗
            rejectDialogShow: false,
            rejectForm: {
                id: null,
                rejectReason: ''
            },
            rejectRules: {
                rejectReason: [{ required: true, message: '请填写拒绝原因' }]
            }
        };
    },
    computed: {
        // 当前审核 tab 对应的 URL query tab 值（用于参数恢复匹配）
        queryTabValue() {
            return this.auditType == 1 ? 'createAudit' : 'editAudit';
        },
        // 审核状态 tag 颜色：0 待审核(蓝) 1 已通过(绿) 2 已拒绝(红) 3 已撤销(灰)
        auditStatusMap() {
            return {
                0: '',
                1: 'success',
                2: 'danger',
                3: 'info'
            };
        }
    },
    mounted() {
        this.getDataList();
    },
    methods: {
        // 判断 URL query 的 tab 是否与当前审核 tab 匹配（redirect 返回/刷新场景才恢复 query 参数）；注意不依赖 computed，data() 初始化时 computed 尚未就绪
        isQueryTabMatched() {
            const tabVal = this.auditType == 1 ? 'createAudit' : 'editAudit';
            return this.$route.query.tab == tabVal;
        },
        // 获取审核列表
        getDataList() {
            this.listLoading = true;
            // 不限制时不传 auditStatus，后端默认排除已撤销的记录
            const _data = {
                pageNo: this.params.pageNo,
                pageSize: this.params.pageSize,
                auditType: parseInt(this.auditType)
            };
            if (this.params.auditStatus != -1) {
                _data.auditStatus = this.params.auditStatus;
            }
            this.$request({
                url: "/share/activity/audit/list",
                method: "POST",
                data: _data
            })
                .then((res) => {
                    const { state, msg, result } = res.data;
                    if (state == 1 && result) {
                        this.data = result;
                        this.dataList = result.result || [];
                    } else {
                        this.$message.error(msg || "请求失败");
                    }
                })
                .catch(() => {
                    this.$message.error("请求错误");
                })
                .finally(() => {
                    this.listLoading = false;
                });
        },
        // 搜索（重置页码）
        search() {
            this.params.pageNo = 1;
            this.getDataList();
        },
        // 重置搜索（保留 pageSize）
        reset() {
            this.params = {
                ...defaultParams,
                pageSize: this.params.pageSize
            };
            this.getDataList();
        },
        // 修改每页条数
        handleSizeChange(e) {
            this.params.pageNo = 1;
            this.params.pageSize = e;
            this.getDataList();
        },
        // 跳转审核详情页
        toDetail(row) {
            this.$router.push({
                path: `/promotion/shareActivity/auditDetail/${row.id}`,
                query: {
                    auditType: parseInt(this.auditType),
                    v: this.$utils.uuid(),
                    // 保存列表状态（含当前 tab），返回时还原
                    redirect: this.$utils.objArgs(this.$router.currentRoute.path, {
                        tab: this.tabName || (this.auditType == 1 ? 'createAudit' : 'editAudit'),
                        ...this.params
                    })
                }
            });
        },
        // 通过审核（二次确认）
        approve(row) {
            this.$confirm('是否确认通过该分享活动审核？', '提示', {
                type: 'warning',
                center: true,
                closeOnClickModal: false
            }).then(() => {
                this.listLoading = true;
                this.$request({
                    url: "/share/activity/audit/approve",
                    method: "POST",
                    params: { auditId: row.id }
                })
                    .then((res) => {
                        const { state, msg } = res.data;
                        if (state == 1) {
                            this.$message.success("审核通过");
                            this.getDataList();
                        } else {
                            this.$message.error(msg || "请求失败");
                        }
                    })
                    .catch(() => {
                        this.$message.error("请求错误");
                    })
                    .finally(() => {
                        this.listLoading = false;
                    });
            }).catch(() => { });
        },
        // 打开拒绝弹窗
        openReject(row) {
            this.rejectForm = {
                id: row.id,
                rejectReason: ''
            };
            this.rejectDialogShow = true;
        },
        // 提交拒绝
        submitReject() {
            this.$refs.rejectForm.validate((valid) => {
                if (!valid) return false;
                this.btnLoading = true;
                this.$request({
                    url: "/share/activity/audit/reject",
                    method: "POST",
                    params: {
                        auditId: this.rejectForm.id,
                        rejectReason: this.rejectForm.rejectReason
                    }
                })
                    .then((res) => {
                        const { state, msg } = res.data;
                        if (state == 1) {
                            this.$message.success("已拒绝");
                            this.rejectDialogShow = false;
                            this.getDataList();
                        } else {
                            this.$message.error(msg || "请求失败");
                        }
                    })
                    .catch(() => {
                        this.$message.error("请求错误");
                    })
                    .finally(() => {
                        this.btnLoading = false;
                    });
            });
        }
    }
};
</script>
